function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_50_8352)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.30468 6.8074H8.31182V5.75582H4.30468V6.8074ZM4.30468 5.29161H8.31182V4.24003H4.30468V5.29161ZM2.51325 3.77582L6.30611 1.56371L10.1032 3.78056V7.86371H2.50896V3.77582H2.51325ZM6.30611 0.280029L0.400391 3.66213V4.8274H1.35182V9.02424H11.2647V4.8274H12.2161V3.66213L6.30611 0.280029Z",
  fill: "#9D9D9D"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_50_8352"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 9,
  fill: "white",
  transform: "translate(0.400391 0.280029)"
})));

function SvgIcHome2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome2);
export default __webpack_public_path__ + "static/media/icHome2.a9b691421d69c2136ce557156f0fb57d.svg";
export { ForwardRef as ReactComponent };